import type { NavMegaMenuGroup, NavMegaMenuLink } from '../types/navigation';

type MegaMenuBadgeColor = NonNullable<NavMegaMenuLink['badgeColor']>;

export const getMegaMenuLinkBadgeColor = (link: NavMegaMenuLink): MegaMenuBadgeColor =>
  link.badgeColor ?? 'magenta';

export const getMegaMenuGroupDotColor = (
  group?: NavMegaMenuGroup,
): MegaMenuBadgeColor | undefined => {
  const colors = (group?.links ?? [])
    .filter((link) => link.badge)
    .map(getMegaMenuLinkBadgeColor);

  if (colors.length === 0) return undefined;

  return colors.every((color) => color === colors[0]) ? colors[0] : 'magenta';
};
